import React from 'react';

import { Identities } from '../../components';

function Dashboard() {
  return <Identities />;
}

export default Dashboard;
